<template>
  <div class="introduceTwo" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <!--导航-->
      <div class="z_nav">
        <div class="m_nav">
          <div class="m_nav_r">
            <ul>
    <!--          <li @click="topOne" :class="{active: 0<= scrollTop < 3475}"><a>發明冬蟲夏草純粉片</a></li>
              <li @click="topTwo" :class="{active: 3475<= scrollTop < 4327}"><a>食品身份，安全放心</a></li>
              <li @click="topThree" :class="{active: 4327<= scrollTop < 5406}"><a>有限資源，高效利用</a></li>
              <li @click="topFour" :class="{active: 5406<= scrollTop < 6691}"><a>比原草更具三大優勢</a></li>
              -->
              <li v-for=" ( item , index ) in nav"
                  :key="item.id"
                  @click="selectMenu(index,$event)"
                  :class="{active:currentIndex == index}">
                <a>{{item}}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!--content-->
      <div class="z_md_one" ref="z_md_one">
        <div class="heightTOP comWidth bankuanOne">
          <div class="one">
            <div>
              <h3>發明冬蟲夏草純粉片</h3>
              <p>
                冬蟲夏草物理加工領域最高科技成果 <br>
                專利技術，精華成分釋放比冬蟲夏草原草提升至少7倍<br>
                創新增加口含黏膜吸收通道，實現口、咽、胃腸多通道高效吸收<br>
                比服用冬蟲夏草原草，更具三大優勢：高效、安全、省錢
              </p>
            </div>
            <router-link :to="{name:'ProductPage'}" tag="a">
              <img src="../../assets/advertisement/zt2-pic1.jpg" alt="">
            </router-link>
          </div>
          <div class="clearBoth"></div>
          <div class="c_ztbox"></div>
          <div class="comWidth">
            <h3 class="bu">核心專利：<b>區離粉碎增溶技術</b></h3>
            <h3>比冬蟲夏草原草至少多7倍精華溶出</h3>
            <img src="../../assets/advertisement/zt2-pic2.jpg" alt="">
            <p class="red">通過區離粉碎增溶技術將冬蟲夏草製成微粉，冬蟲夏草中的總物質溶出</p>
            <p>3分鐘內比冬蟲夏草原草高10-15倍，5分鐘內仍比原草高至少7倍</p>
            <p>原草在短時間內溶出量很少，60分鐘時，原草的溶出總量，僅為區離粉碎增溶技術製成的微粉的50%</p>
            <img src="../../assets/advertisement/zt2-pic3.jpg" alt="">
            <p>
              冬蟲夏草區離粉碎增溶技術的創新使用，充分考慮了冬蟲夏草不同部位生物結構的差異性，有效提升了精華成分的溶出。
              <br>將蟲體和子座分開的區離粉碎的方式，相比於將整根全草直接粉碎，一些重要的活性成分的
            </p>
            <p class="red">溶出總量在1分鐘內即高出28%以上，在45分鐘內仍高出15%以上.</p>
            <img src="../../assets/advertisement/zt2-pic4.jpg" alt="">
          </div>
          <div class="comWidth ">
            <h3>核心專利：<b>純粉多維成型技術</b></h3>
            <h3>含著吃，多通道吸收，更快更高效</h3>
            <img src="../../assets/advertisement/zt2-pic5.jpg" alt="">
            <p class="red" >增加口含黏膜吸收新通道</p>
            <p>專利的純粉多維成型技術，實現100%純粉無添加劑壓片，創新增加冬蟲夏草口含黏膜吸收新途徑，實現多通道高效吸收。</p>
            <p class="red">口、咽、胃腸局部及全身的雙重呵護</p>
            <p>
              含服期間，四十余種揮發性物質直接進入血液，多重精華迅速發散於血液、咽喉、消化道黏膜，持續高濃度釋放，調整平衡細胞功能；黏膜吸收，精華成分直接進入全身血液循環，無胃腸道和肝臟的首過效應，超倍快速吸收！充分發揮對局部（口腔、咽喉、食道、胃腸道黏膜）及全身的雙重呵護作用。
            </p>
            <p>
              冬蟲夏草含服方式，還可以充分刺激唾液（津液）的分泌。 《黃帝內經》雲：“脾延津，腎歸唾。”
              唾液有灌溉臟腑、利脾、健胃、強腎、潤澤肌膚的重要作用，與極草7倍釋放的強大陰陽同補功效相輔相成，呈現完美的效果體驗。
            </p>
            <p class="red">含著吃，多通道吸收，更快更高效</p>
            <p>
              區離粉碎增溶技術帶來的、比原草至少提升7倍的精華成分釋放，通過口含黏膜吸收通道的增加，結合胃腸道吸收途徑，極大的提高了冬蟲夏草的生物利用度。
            </p>
          </div>
          <div class="comWidth flex">
            <h3>口含黏膜吸收，部分精華成分直接進入血液循環</h3>
            <div class="clearBoth"></div>
            <div class="fl">
              <img src="../../assets/advertisement/zt2-pic6.jpg" alt="" class="fl">
              <div class="fr" >
                <p>
                  人體能夠吸收藥物的消化途徑主要包含口腔、咽喉、食道、胃、小腸、直腸。通常口服吸收的主要位置是胃和小腸，但從胃和小腸吸收的成分會被肝臟代謝分解一部分（這個過程稱為“首過效應”），使進入全身血液循環的藥量減少、藥效降低，比如，用於急性心絞痛的硝酸甘油，口服利用率只有10%-20%（如下表）。近年來，大量現代藥理學和生物學研究表明，許多藥物可通過黏膜吸收，繞過首過效應，具有更高的生物利用度。
                </p>
                <img width="780" src="../../assets/advertisement/zt4_tab3.jpg" alt="">
              </div>
            </div>
            <div class="clearBoth"></div>
            <p>參考文獻</p>
            <p>1.冬蟲夏草蟲體、子座區離粉碎微粉總溶出物研究報告，中國測試技術研究院生物研究所，2015。</p>
            <p>2.藥理學[衛生部[十一五]規劃教材、全國高考學校教材].主編楊世傑，人民衛生出版社</p>
            <p>3.藥理學[全國高等中醫藥學教材]，主編黃敬耀，人民衛生出版社</p>
          </div>
          <div class="c_ztbox"></div>
        </div>
        <div class="heightTOP comWidth bankuanTwo ">
          <h3>極草·5X冬蟲夏草純粉片</h3>
          <h3>經澳門特別行政區政府批准在澳門生產</h3>
          <h3>產品完全符合澳門的產品安全與品質標準</h3>
          <div class="clearBoth"></div>
          <div class="clearBoth"></div>
          <p> 極草·5X冬蟲夏草純粉片由澳門衛生局審批分類為非「藥物（西藥）」、「中成藥」或「傳統（天然）藥物」，按照食品相應法例進行管理。</p>
          <p>根據澳門《食品安全法》（澳門特別行政區第5/2013號法律）及相應法例所要求的標準，極草·5X冬蟲夏草純粉片完全符合澳門</p>
          <p>對食品中的致病性微生物、農藥殘留、獸藥殘留、重金屬、放射性物質及其他危害人體健康物質的限量規定。</p>
          <div class="tab-flex2">
            <div><img src="../../assets/advertisement/zt4_tab5.jpg" alt=""></div>
            <div>
              <p>微生物質量的判斷可分為下列三級[1]：</p>
              <p>•滿意：檢測結果顯示食品微生物含量狀況良好。</p>
              <p>•尚可：檢測結果屬於可接受含量的上限，這顯示其可能存有食品安全風險的潛在性。</p>
              <p>•不滿意：就需氧菌落計數方面，檢測結果顯示可考慮調查數值偏高的原因。衛生指示微生物方面，檢測結果顯示須採取改善措施。致病性微生物方面，檢測結果的含量顯示有關產品可能損害食用者健康，須立即採取改善措施。</p>
            </div>
          </div>
          <div class="tab-flex2">
            <div><img src="../../assets/advertisement/zt4_tab6.jpg" alt="">
            </div>
            <div>
              <p> 1. 澳門民政部署食品安全中心《即食食品微生物含量指引》（GL 009 CSA 2015）</p>
              <p>2. 澳门《關於傳統藥物重金屬及有毒元素含量上限的技術性指示》（第10/SS/2013號卫生局局长批示）</p>
            </div>
          </div>
          <div class="c_ztbox"></div>
        </div>
        <div class="heightTOP comWidth bankuanThree">
          <h3>獲得青海春天藥用資源科技利用有限公司專利、品牌授權</h3>
          <div class="clearBoth"></div>
          <p class="a0">由青海春天提供產品技術支持、品控指導等服務</p>
          <h3>極草·5X冬蟲夏草純粉片嚴格遵照極草·5X冬蟲夏草體系進行生產</h3>
          <p class="a0">極草·5X冬蟲夏草體系是青海春天歷時數年，潛心研究，智慧開創的冬蟲夏草領域的最高標準。</p>
          <div>
            <div class="cir-icon">
              <div>
                <img src="../../assets/advertisement/ciricon1.png" alt="">
              </div>
              <div>
                <p><b>優質原草精選系統</b></p>
                <p>澳門極草的全部冬蟲夏草原料，均由專業的冬蟲夏草鑒定師團隊，遵照最嚴格的收購標準和收購體系、利用精密儀器設備與現代生物學技術進行檢選收購，實現外在品質鑒定與內在品質精選，保證成為極草的每一棵冬蟲夏草都是更具功效價值的精選優質原草。</p>
              </div>
            </div>
            <div class="cir-icon">
              <div>
                <img src="../../assets/advertisement/ciricon2.png" alt="">
              </div>
              <div>
                <p><b>常溫生服淨化系統</b></p>
                <p>通過專業深度清洗、低溫幹燥技術、滅菌，去除致病細菌、寄生蟲（卵）、真菌等有害物質，達到適合常溫生服基本要求的直接服用級標準。</p>
              </div>
            </div>
            <div class="cir-icon">
              <div>
                <img src="../../assets/advertisement/ciricon3.png" alt="">
              </div>
              <div>
                <p><b>區離粉碎增溶技術</b></p>
                <p>冬蟲夏草蟲體與子座分開，定位粉碎，均勻打破冬蟲夏草細胞結構，達到適合人體吸收的恰當粒徑，精華成分釋放比原草突破性提升至少7 倍，藥力高效釋放。</p>
              </div>
            </div>
            <div class="cir-icon">
              <div>
                <img src="../../assets/advertisement/ciricon4.png" alt="">
              </div>
              <div>
                <p><b>純粉多維成型技術</b></p>
                <p>實現100% 純粉無添加劑壓片，增加口內含服、黏膜吸收新通道，保證了冬蟲夏草精華成分被充分利用，直接進入人體血液循環，無胃腸道及肝臟的首過效應，高效方便。</p>
              </div>
            </div>
            <div class="cir-icon">
              <div>
                <img src="../../assets/advertisement/ciricon5.png" alt="">
              </div>
              <div>
                <p><b>多重保護密封包裝</b></p>
                <p>流通環節摻假增重行為無機可乘，避免潔淨產品被污染。保持品質恒定，質保更長久，直接食用。</p>
              </div>
            </div>
          </div>
          <div class="c_ztbox"></div>
        </div>
        <div class="heightTOP comWidth bankuanFour">
          <h3>極草·5X冬蟲夏草純粉片，比原草更具三大優勢</h3>
          <ul>
            <li>
              <p class="red">1.高效</p>
              <div>
                <p>同等研究條件下，極草的冬蟲夏草中總物質溶出量遠高於原草。含服瞬間（1 分鐘內）即開始高濃度釋放，這種優勢持續至少60 分鐘，極利於吸收。</p>
                <p>極草將冬蟲夏草製成純粉片，通過含服增加口腔黏膜吸收，精華成分直接進入血液循環，避免首過效應，為提高冬蟲夏草的生物利用度增加了一個快速高效的途徑。</p>
              </div>
            </li>
            <li>
              <p class="red">2.安全</p>
              <div>
                <p>極草產品為工業化生產，每批投料幾十公斤以上，每根原料草均經過嚴格的8 步檢測（真偽、水分、雜質、多元素及重金屬、異物、蟲蛀、傷痕、重量與子座蟲體比例），完成安全性與初步的質量評價，方可進入正式生產工序。</p>
                <p>原料草經專業清洗後，在顯微鏡下逐根檢測潔淨程度，剖開檢查內部，再經異物檢測儀檢測，合格後低溫乾燥滅菌，進入區離粉碎工序。粉碎制得的粉體再經過嚴格全面的質量檢測，合格才能進行壓片。成品還需再依据质量标准进行全项檢測，合格方可出廠。因此，極草產品是非常安全的。</p>
                <p>使用市場上銷售的原草，也應對每一根進行檢查才能放心吃。然而，現在的造假增重手段，即使是專業人士，如果不借助專業儀器與技術，也很難分辨。敬請特別注意！</p>
              </div>
            </li>
            <li>
              <p class="red">3.省錢</p>
              <div>
                <p>按照功效研究確定的有效服用量服用，原草重要成分的溶出比極草純粉含片低很多，日均花費卻遠高於極草：</p>
                <p>《中華人民共和國藥典》對原草的建議服用量為3-9克；</p>
                <p>經功效研究確定並由權威部門批准，極草的推薦服用量為1-3.5克。</p>
              </div>
            </li>
          </ul>
          <div class="m20" >
            <img src="../../assets/advertisement/tab.jpg" alt="" style="width: 100%">
          </div>
          <h4 >說明：</h4>
          <p class="small">極草純粉含片比原草至少多7倍精華的溶出，口含吸收帶來了利用度更高、效果更快更好。</p>
          <p class="small">市場上購買的原草，您吃到嘴裡的重量，還得再打個7折。因為在蟲頭部及蟲體皺褶中隱藏著不易看見的泥沙雜質，即使肉眼看起來比較幹淨，但這些隱藏的泥沙雜質，也通常佔原草重量的30%以上。也就是說，去掉這30%無效重量，原草花費至少高達經典含片的1.9倍。</p>
          <p class="small">不僅如此，由於原草水分含量在低於11%時，運輸和銷售中易於折斷損耗，因而市售原草水分含量通常高於14%，比極草純粉片嚴格內控在10%以內的水分含量，又高出至少4%。</p>
          <p class="small">我們在研究中發現，冬蟲夏草原草在水中浸泡一分鐘，藥效成分已經開始有溶出。如果想清洗幹淨，尤其是將蟲體皺褶中的泥沙洗淨，需要浸泡更長的時間，冬蟲夏草有效成分會有大量損失。</p>
          <div class="m20" >
            <img src="../../assets/advertisement/jc_zt_sec4_img1.gif" alt="">
          </div>
          <div class="c_ztbox"></div>
        </div>
        <div class="heightTOP comWidth bankuanFive">
          <h3>極草榮譽</h3>
          <div class="flex-around">
            <div class="hornor">
              <img src="../../assets/advertisement/zt2-pic13.jpg" alt="">
              <p>中醫藥現代化獲高度肯定，聯合國秘書長特別助理頒獎極草總設計師「國際健康成就獎」</p>
            </div>
            <div class="hornor">
              <img src="../../assets/advertisement/zt2-pic14.jpg" alt="">
              <p>世界壓片機行業領導品牌德國菲特公司授予極草總設計師張雪峰先生「榮譽工程師」</p>
            </div>
          </div>
          <div class="flex-around">
            <div class="medal-3">
              <img src="../../assets/advertisement/medal1.jpg" alt="">
              <p>極草總設計師張雪峰先生獲第七屆健康中國（2014年度）年度創新人物</p>
            </div>
            <div class="medal-3">
              <img src="../../assets/advertisement/medal2.jpg" alt="">
              <p>青海春天極草產品榮獲第七屆健康中國（2014年度）消費者信賴的高端滋補品牌</p>
            </div>
            <div class="medal-3">
              <img src="../../assets/advertisement/medal3.jpg" alt="">
              <p>青海春天被人民日報社《健康時報》授予2009健康中國卓越貢獻獎</p>
            </div>
          </div>
          <div class="flex-around">
          </div>
          <div class="flex-around">
            <div class="medal-3">
              <img src="../../assets/advertisement/medal4.jpg" alt="">
              <p>極草總設計師總設計師張雪峰先生，在2011年、2012年、2013年，連續三年榮獲由國家科技部、商務部等單位聯合頒發的「中國自主創新領軍人物」</p>
            </div>
            <div class="medal-3">
              <img src="../../assets/advertisement/medal5.jpg" alt="">
            </div>
            <div class="medal-3"><img src="../../assets/advertisement/medal6.jpg" alt=""></div>
            <div class="medal-3"><img src="../../assets/advertisement/medal7.jpg" alt=""></div>
          </div>
          <p style="padding-left: 366px;margin-top: -132px;padding-bottom: 132px;">
            青海春天在2011年、2012年、2013年分別被授予中國自主創新卓越品牌和中國自主創新傑出貢獻獎
          </p>
          <img src="../../assets/advertisement/zt2-pic11.jpg" alt="">
          <p style="text-align: center;margin: 30px 0;">極草嚴苛的生產標準和穩定的產品質量，深受泰國前總理他信和英拉的贊賞，多次蒞臨極草專賣店購買極草產品。</p>
          <img src="../../assets/advertisement/zt2-pic12.jpg" alt="">
          <div class="clearBoth"></div>
          <p style="float: left;margin: 30px 0;margin-left: 108px;">青海省政府將極草作為青海省代表禮物贈與世界著名男高音歌唱家何塞·卡雷拉斯先生。</p>
          <p style="float: right;margin: 30px 0;margin-right: 108px;">國際奧委會執委、國際現代五項聯合會主席舒曼先生盛贊極草</p>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
//  import BScroll from 'better-scroll';
  export default {
    name: 'IntroduceTwo',
    data () {
      return {
        nav:['發明冬蟲夏草純粉片','食品身份，安全放心','有限資源，高效利用','比原草更具三大優勢','極草榮譽'],
        //保存每一个分类的clientHeight
        listHeight:[],
        //当前滚动的y位置
        scrollTop: 0
      }
    },
    methods:{
      /*获取滚动条距离浏览器窗口顶部高度*/
      handleScroll () {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      },
      _calculateHeight(){
        let foodlist = this.$refs.z_md_one.getElementsByClassName('heightTOP');
        let height= 0;
        this.listHeight.push(height);
        for( let i=0; i<foodlist.length; i++){
          let item = foodlist[i];
          if (i === 1) {
            height+= 180;
            height+= item.clientHeight;
          }else {

          height+= item.clientHeight;
          }
          this.listHeight.push(height);
        }
      },
      //选择菜单
      selectMenu(index,event){
        let foodList = this.$refs.z_md_one.getElementsByClassName('heightTOP');
        let el = foodList[index];
        el.scrollIntoView(true);
      },
/*      // 点击了添加,获取点击对象
      drop(target){
        //体验优化  异步执行下拉动画
        this.$nextTick(()=>{
          this.$refs.shopcart.drop(target)
        })
      }*/
    },
    computed:{
      currentIndex(){
        for(let i=0; i<this.listHeight.length;i++){
          let height1 = this.listHeight[i];
          let height2 = this.listHeight[i+1];
          if(!height2 || this.scrollTop>=height1 && this.scrollTop<height2){
            return i
          }
          if(this.scrollTop >= this.listHeight[4]){
              return 4;
          }
        }
        return 0
      }
    },
    mounted () {
        this._calculateHeight();
     window.addEventListener('scroll', this.handleScroll);
      window.scrollTo(0,0)
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import "../../css/introduceTwo.less";
</style>
<style>

</style>



// WEBPACK FOOTER //
// src/pages/advertisement/IntroduceTwo.vue